import { registerSiteContent } from '@/features/siteContent/runtime';

/**
 * The platform's own brand: the name, the lockup and the default page title.
 * Editable by the platform owner under Site content -> Branding.
 *
 * The wordmark is two halves so the second can wear the brand colour, the way
 * "Neon" and "Carts" always have.
 */
export const BRANDING = {
  name: 'NeonCarts',
  wordmarkStart: 'Neon',
  wordmarkAccent: 'Carts',
  /** The line under the wordmark on full lockups, as on the sign-in artwork. */
  tagline: 'Sell Smarter Grow Faster',
  /** The mark beside the wordmark. Landscape artwork; height drives it. */
  logoSrc: '/images/logo.png',
  /** Shown instead of the default favicon when set. */
  faviconSrc: '',
  /** The home page's tab title and search description. */
  homeTitle: 'NeonCarts - AI Commerce OS for Indian Businesses',
  homeDescription:
    'Launch your online store in 10 minutes. Build your store, manage orders, engage customers on WhatsApp and grow with AI - all in one platform.',
};

registerSiteContent('branding', { BRANDING });
